<template>
  <div class="row">
    <div class="col">
      <div class="card">
        <div class="row">
          <div class="col">
            <div class="card-header row">
              <div class="col">
                <h4 class="card-title float-left">Vehicles</h4>
              </div>
              <div class="col">
                <router-link class="btn btn-primary float-right" :to="{path:'/admin/vehicles/vehicles/0/create'}">ADD VEHICLE</router-link>
              </div>
            </div>
            <div class="card-body">
              <DataTable endpoint="vehicles/vehicle" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import DataTable from '@kaweb-ltd/admin-vue/DataTable.vue'

  export default {
    components: {
      DataTable
    },
    data () {
      return {
      }
    }
  }
</script>
<style>

</style>
